import { atomWithReset } from "jotai/utils";

import type { RegulatoryDocumentDraft } from "@/lib/form-schemas/regulatory-document-schema";

export const regulatoryDocumentAtom = atomWithReset<RegulatoryDocumentDraft>({
  codTipoDocumentoRegulatorio: 0,
  documentName: "",
  codMotivoDocumento: 0,
  reasonLabel: "",
  requiresJustification: false,
  justification: "",
  selectedLocations: [],
  siglaUF: "",
  stateLabel: "",
  coveredLocations: [],
  temEntradasDiferentes: false,
  requiresLocationIn: [],
});
